import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AwsEnvironment } from '../aws/environment';
import { ErrorHandler } from '../restapi/error-handler';
import { User } from '../user/user';
import { UserLogin } from './user-login';
import {AttackProfile} from '../attack/attack';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class LoginService {

    userLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private http: Http, private awsEnv: AwsEnvironment, private errorHandler: ErrorHandler) { }

    login(userLogin: UserLogin): Observable<User> {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let baseRegistrationUrl = this.awsEnv.getRegistrationUrl();
        let url = `${baseRegistrationUrl}/login`;
        return this.http
            .post(url, JSON.stringify(userLogin), { headers: headers })
            .map((response: Response) => response.json())
            .catch((response: Response) => this.errorHandler.throwError(response));
    }

    userLoggedIn( value: boolean){
        this.userLoggedInSubject.next(value);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/user-login.service.ts